"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preprocessIonizations = preprocessIonizations;
const mf_parser_1 = require("mf-parser");
function preprocessIonizations(ionizationsString = '') {
    if (Array.isArray(ionizationsString))
        return ionizationsString;
    const ionizations = ionizationsString.split(/ *[\t\n\r,.;]+ */);
    // it is allowed to have ranges in Ionizations. We need to explode them.
    const results = [];
    for (const ionization of ionizations) {
        const parts = new mf_parser_1.MF(ionization).flatten();
        for (const part of parts) {
            const info = new mf_parser_1.MF(part).getInfo();
            results.push({
                mf: part,
                em: info.monoisotopicMass,
                charge: info.charge,
                atoms: info.atoms,
            });
        }
    }
    return results;
}
//# sourceMappingURL=preprocessIonizations.js.map